import React from 'react'
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';

function ViewCustomers() {
  const { customersViewId } = useParams();
  const location = useLocation();
  const data = location.state.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  return (
    <div className="w-full h-full p-2 lg:px-4 ">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Customers",
              link: "/sales/customers",
            },
            { name: "View" },
          ]}
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link
            to={"/sales/customers"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/sales/customers/edit/${customersViewId}`}
            state={{
              data: data,
              from: `/sales/customers/view/${customersViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div>
      <div className="w-full mx-auto md:h-[calc(100vh-145px)] bg-white rounded-md mt-4 overflow-y-auto p-2 lg:p-3">
        <NormalHeading title={data?.companyName || "Customer Details"} />
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="w-full rounded-lg bg-white py-2 flex flex-col">
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Customer Type
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.customerType || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Email
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.email || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Phone
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.phoneWithCC || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Designation
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.designation || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Website
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.website || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Category
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.category || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Industry
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.industry || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Sales Person
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.assigned_sales_person || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person Name
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.cpName || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person Email
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.cpEmail || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person Phone
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.cpPhoneWithCC || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                CR Num
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.crNum || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Vat Num
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.vatNum || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Ratings
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.ratings || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Payment Term
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.paymentTerm || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Credit Limit
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.creditLimit || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Comments
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.comments || "-"}
              </p>

            </div>
          </div>

          <div className="w-full rounded-lg bg-white py-2 flex flex-col">
            <div className="bg-gray-100 w-full flex px-2 py-1 rounded">
              <p className="w-full text-[13px] font-semibold text-[#111537]">
                Billing Address
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 1
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.billingAddress1 || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 2
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.billingAddress2 || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                City
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.billing_city || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                State / Province
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.billing_state || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Country
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.billing_country || "-"}
              </p>
            </div>

            <div className="bg-gray-100 w-full flex px-2 py-1 rounded mt-3">
              <p className="w-full text-[13px] font-semibold text-[#111537]">
                Shipping Address
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 1
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shippingAddress1 || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 2
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shippingAddress2 || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                City
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shipping_city || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                State / Province
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shipping_state || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Postal / Zip Code
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shipping_postal_code || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Country
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.shipping_country || "-"}
              </p>
            </div>
          </div>
        </div>
      </div></div>
  );
}
export default ViewCustomers;